/* Form Component in the DayPage to create a Schedule Scene 
 * Remove from DRF location_detail, dramatic_day, pages
    */
import React, { useState } from "react";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
// import { useCurrentUser } from "../../../contexts/CurrentUserContext";
import styles from "../../../styles/ScheduleCreate.module.css";
import btnStyles from "../../../styles/Button.module.css";

const SceneScheduleCreate = ({
  xday,
  xdate,
  setShow,
  setHasOrder,
  epi,
  project,
  episodeTitle,
  day_id,
}) => {
  const host = useHostName();
  // const currentUser = useCurrentUser();
  const [errors, setErrors] = useState({});
  const { id } = useParams();
  // const [query, setQuery] = useState("");
  // const projectType = currentUser?.project_category_type
  //   ? JSON.parse(currentUser?.project_category_type)
  //   : null;

  const [postData, setPostData] = useState({
    day_order_number: "",
    start_time: "",
    end_time: "",
    number: "",
    location: "",
    int_ext: "",
    day_night: "",
    action: "",
    filming_location: "",
    location_address: "",
    time: "",
    title: "",
    equip_set_props: "",
    department_info: "",
    act: "",
    new_info: "",
    next: "",
  });

  const {
    day_order_number,
    start_time,
    end_time,
    number,
    location,
    int_ext,
    day_night,
    action,
    filming_location,
    location_address,
    time,
    title,
    equip_set_props,
    department_info,
    act,
    new_info,
    next,
  } = postData;

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    if (day_order_number === "" || !day_order_number) {
      toast.error("Scene Order Number is required");
      return;
    }
    formData.append("scene_id", "");
    formData.append("is_second_unit", true);
    formData.append("day_id", id);
    formData.append("day", xday);
    formData.append("date", xdate);
    formData.append("day_order_number", day_order_number);
    formData.append("start_time", start_time);
    formData.append("end_time", end_time);
    formData.append("number", number);
    formData.append("int_ext", int_ext);
    formData.append("day_night", day_night);
    formData.append("location", location);
    formData.append("action", action);
    formData.append("filming_location", filming_location);
    formData.append("location_address", location_address);
    formData.append("time", time);
    formData.append("title", title);
    formData.append("equip_set_props", equip_set_props);
    formData.append("department_info", department_info);
    formData.append("act", act);
    formData.append("new_info", new_info);
    formData.append("next", next);
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.post("/schedule/scenes/", formData);
        setShow(false);
        setHasOrder(true);
        toast.success(`Schedule Scene Added`);
      } else {
        await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/schedule/scenes/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setShow(false);
        setHasOrder(true);
        toast.success(`Schedule Scene Added Successfully!`);
      }
    } catch (err) {
      console.log(err);
      if (err.response?.status !== 401) {
        setErrors(err.response?.data);
      }
    }
  };

  const textFields = (
    <div>
      {/*  Description - using action
           bg using title
           Stunts/SFX - using department_info  
           shoot info - using new_info
           cast - using act
           Parking - using time  */}
      {/* order start est */}
      <Row>
        <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-md-2">
        <Form.Group controlId="day_order_number" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >
                <span className= "d-md-none">Order Number</span>
                <span className="d-none d-md-block">Scene Order Number</span>
                </Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="day_order_number"
              value={day_order_number}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.day_order_number?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={6} md={4} className="d-flex justify-content-center mt-3 mt-md-0 p-0 p-md-2">
          <Form.Group controlId="start_time" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Start Time</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="start_time"
              value={start_time}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.start_time?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={6} md={4} className="d-flex justify-content-center mt-3 mt-md-0 p-0 p-md-2">
          <Form.Group controlId="end_time" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Est. Time</Form.Label>
              <Form.Control
              className={`${styles.Input}`} 
              type="text"
              name="end_time"
              value={end_time}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.end_time?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      {/* hr */}
      <hr/>
      {/* scene number - scene loc - int-ext - day-night */}
      <Row>
        <Col xs={6} md={3} className="d-flex justify-content-center p-0 p-md-2">
        <Form.Group controlId="number" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Scene Number</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="number"
              value={number}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.number?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={6} md={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="location" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Scene Location</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location"
              value={location}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2" xs={6} md={3} >         
          <Form.Group controlId="int_ext" className={`${styles.Width2} `} >
              <Form.Label className={`${styles.BoldScene}`} >Int-Ext</Form.Label>
              <Form.Control as="select"
                className={styles.InputEx}
                name="int_ext"
                value={int_ext}
                onChange={handleChange}
                aria-label="int ext select">
                <option></option>
                <option value="int.">Int</option>
                <option value="ext.">Ext</option>
              </Form.Control>
          </Form.Group>
          {errors?.int_ext?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      <Col className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2" xs={6} md={3} >
      <Form.Group controlId="day_night" className={`${styles.Width2} `} >
          <Form.Label className={`${styles.BoldScene}`} >Day/Night</Form.Label>
          <Form.Control as="select"
            name="day_night"
            className={styles.InputEx}
            value={day_night}
            onChange={handleChange}
            aria-label="day or night select">
            <option></option>
            <option value="DAY">Day</option>
            <option value="NIGHT">Night</option>
          </Form.Control>
      </Form.Group>
      {errors?.day_night?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      {/* hr */}
      <hr/>
      {/*  footage  */}
      <Row>
        <Col xs={12} md={{span: 10, offset: 1}} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
        <Form.Group controlId="action" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Footage Description</Form.Label>
              <Form.Control 
              className={`${styles.InputScene}`}
              type="text"
              name="action"
              value={action}
              as="textarea"
              rows={2}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.action?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      <hr />
      {/*  filming location name - address - parking using time */}
      <Row>
      <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-md-2">
        <Form.Group controlId="filming_location" className={`${styles.Width2} `}  >
            <Form.Label >
              <p className={`${styles.BoldScene}`}>Filming Location Name</p>
            </Form.Label>
            <Form.Control 
            className={`${styles.Input}`}
            type="text"
            name="filming_location"
            value={filming_location}
            onChange={handleChange}
                />
        </Form.Group>
        {errors?.filming_location?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
      </Col>
      <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="location_address" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene}`} >Filming Location Address</Form.Label>
          <Form.Control 
          className={`${styles.InputScene}`}
          type="text"
          name="location_address"
          as="textarea"
          rows={2}
          value={location_address}
          onChange={handleChange}
              />
      </Form.Group>
      {errors?.location_address?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col> 
      <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="time" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene}`} >Parking/Directions/Notes</Form.Label>
          <Form.Control 
          className={`${styles.InputScene}`}
          type="text"
          name="time"
          as="textarea"
          rows={2}
          value={time}
          onChange={handleChange}
              />
      </Form.Group>
      {errors?.time?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      <hr />
      {/* bg using title - equip - stunts using department_info */}
      <Row>
        <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="title" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >BG/Doubles/Stunt Artists</Form.Label>
              <Form.Control 
              className={`${styles.InputScene}`}
              type="text"
              name="title"
              value={title}
              as="textarea"
              rows={1}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.title?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="equip_set_props" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene}`}>Equipment/Set/Props</Form.Label>
          <Form.Control 
              className={`${styles.InputScene}`}
              type="text"
              name="equip_set_props"
              as="textarea"
              rows={1}
              value={equip_set_props}
              onChange={handleChange}
              />
          </Form.Group>
          {errors?.equip_set_props?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
        <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="department_info" className={`${styles.Width2} `}  >
          <Form.Label >
            <p className={`${styles.BoldScene}`}>Stunts/SFX</p>
            </Form.Label>
          <Form.Control 
              className={`${styles.InputScene}`}
              type="text"
              name="department_info"
              as="textarea"
              rows={1}
              value={department_info}
              onChange={handleChange}
              />
      </Form.Group>
      {errors?.department_info?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      {/* hr */}
      <hr/>
      {/* cast using act - shoot info using new_info - next */}
      <Row>
        <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-md-2">
        <Form.Group controlId="act" className={`${styles.Width2} `}  >
          <Form.Label >
            <p className={`${styles.BoldScene}`}>Cast</p>
            <p className={`${styles.Para3}`}>Coordinate with Main Unit</p>
            </Form.Label>
          <Form.Control 
              className={`${styles.InputScene}`}
              type="text"
              name="act"
              as="textarea"
              rows={1}
              value={act}
              onChange={handleChange}
              />
          </Form.Group>
          {errors?.act?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="new_info" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene}`}>Shoot Info</Form.Label>
          <Form.Control 
              className={`${styles.InputScene}`}
              type="text"
              name="new_info"
              as="textarea"
              rows={1}
              value={new_info}
              onChange={handleChange}
              />
          </Form.Group>
          {errors?.new_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      <Col xs={12} md={4} className="mt-4 mt-md-0 d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="next" className={`${styles.Width2} `}  >
          <Form.Label >
            <p className={`${styles.BoldScene}`}>Next</p>
            <p className={`${styles.Para3}`}>Add Moves and Meal Breaks here</p>
            </Form.Label>
          <Form.Control 
              className={`${styles.InputSceneNext}`}
              type="text"
              name="next"
              as="textarea"
              rows={1}
              value={next}
              onChange={handleChange}
              />
      </Form.Group>
      {errors?.next?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      {/* hr */}
      <hr />
    </div>
  )

  const buttons = (  
    <div className="mt-4">
    <Button
      className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
      onClick={() => setShow(show => !show)}
    >
      Cancel
    </Button>
    <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
      Submit
    </Button>
    </div>
);

  return (
    <div className="px-3">
      <h5 style={{ textTransform: "uppercase" }}
              className={`mt-1 py-0 text-center ${styles.SubTitle}`}
            >
             2nd UNIT - ADD SCENE<span className={`float-right pt-1 ${styles.Close }`} 
                onClick={() => setShow(false) } >Close</span>
      </h5> 
        <Form className={`text-center ${styles.White }`} onSubmit={handleSubmit}>
        <Row>
        <Col xs={12} className="p-0 p-md-2">
            {textFields}
            {buttons}
        </Col>
        </Row>
        </Form>
      {/* break */}
      <Row className='mb-5 mt-3'>
      <Col xs={2} ></Col>
      <Col xs={8}>
      <hr className={`${styles.Break} mt-0 mb-0 mb-md-1`}/>
      <hr className={`${styles.BreakBlack} my-0`}/>
      </Col>
      </Row>
    </div>
  );
};

export default SceneScheduleCreate;
